// /src/components/YearNavigation.tsx

import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons";

type YearNavigationProps = {
    year: number;
    onYearChange?: (newYear: number) => void;
    showTitle?: boolean;
    className?: string;
};

export function YearNavigation({
    year,
    onYearChange,
    showTitle = true,
    className = "",
}: YearNavigationProps) {
    const { t } = useTranslation();

    return (
        <div className={`flex items-center justify-start gap-4 ${className}`}>
            <button
                type="button"
                onClick={() => onYearChange?.(year - 1)}
                className="hover:bg-compendia-greige-20 border border-transparent hover:border-compendia-border rounded-full w-10 h-10 flex items-center justify-center text-compendia-foreground transition-colors"
                aria-label={t("common.previousYear")}
            >
                <FontAwesomeIcon icon={faChevronLeft} className="w-4 h-4" />
            </button>

            <span className="text-lg font-semibold min-w-16 text-center text-compendia-foreground">
                {showTitle ? t("dashboard.yearlyCycleTitle", { year }) : year}
            </span>

            <button
                type="button"
                onClick={() => onYearChange?.(year + 1)}
                className="hover:bg-compendia-greige-20 border border-transparent hover:border-compendia-border rounded-full w-10 h-10 flex items-center justify-center text-compendia-foreground transition-colors"
                aria-label={t("common.nextYear")}
            >
                <FontAwesomeIcon icon={faChevronRight} className="w-4 h-4" />
            </button>
        </div>
    );
}
